module.exports = __webpack_public_path__ + "img/img-home2@1x.6d0cc684.png";